module.exports = __webpack_public_path__ + "img/silki.22b8fc72.png";